var styleDataHash = "1f358613";
const injectCss = () => {
  var css = `@charset "UTF-8";.ReactModalPortal,.YxJn3,.glob_fontElementMap,.ncDNb,button{font-family:var(--ricos-font-family,unset)}.W3DSA{display:flex}[dir] .dPLTI:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] .dPLTI:hover,[dir] .jx369{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}[dir] .jx369{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] ._2wq6- .jx369{box-shadow:none!important}.qA9Q-{display:block;height:100%;position:absolute;top:0;width:100%}[dir] .qA9Q-{cursor:move}[dir=ltr] .qA9Q-{left:0}[dir=rtl] .qA9Q-{right:0}.qA9Q-.aE8xj{pointer-events:none}[dir] .WrsZ1 ::selection{background:transparent}._6rcMZ{display:none}.YxJn3{position:relative}._24Kvx{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{font-weight:300}[dir=ltr] .ReactModal__Content{direction:ltr}[dir=rtl] .ReactModal__Content{direction:rtl}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.DMRfq{color:#333;text-decoration:none}.jl1tF{display:block}.iXLUr{position:relative}.Ve4La{overflow-x:auto;overflow-y:hidden}[dir=ltr] .Ve4La,[dir=rtl] .Ve4La{margin-left:-20px;margin-right:-20px}[dir] .Ve4La.HDiMO::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}[dir] .Ve4La.DgU2o::-webkit-scrollbar-thumb{background-color:transparent}.Rwicq{max-width:max-content!important;min-width:100%}.Ve4La::-webkit-scrollbar{-webkit-appearance:none}[dir] .Ve4La::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.Ve4La::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_default = {
  "fontElementMap": "ncDNb",
  "pluginContainer": "YxJn3",
  "flex": "W3DSA",
  "isFocusable": "dPLTI",
  "hasFocus": "jx369",
  "dragImageView": "_2wq6-",
  "overlay": "qA9Q-",
  "noPointerEventsOnFocus": "aE8xj",
  "hideTextSelection": "WrsZ1",
  "hidden": "_6rcMZ",
  "pluginContainerMobile": "_24Kvx",
  "isImage": "DMRfq",
  "anchor": "jl1tF",
  "horizontalScrollbarWrapper": "iXLUr",
  "pluginWithHorizontalScrollbar": "Ve4La",
  "show": "HDiMO",
  "hide": "DgU2o",
  "horizontalScrollbar": "Rwicq"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
